/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MY_ASSET_DETAIL = gql`
query GetMyAsset($auth: WalletAuth!, $input: GetMyAssetInput!) {
  getMyAsset(auth: $auth, input: $input) {
    title
    subtitle
    serialNo
    tokenGroup
    tag
    type
    img
    category
    price {
      amount
      type
      currency
      sale {
        salePrice
        saleEndDate
      }
      symbol
    }
    symbol
    attrs {
      name
      val
      disp_type
      disp_val
    }
    media {
      type
      src
      thumbnail
    }
    digitalTwin
    claimEnabled
    owner {
      name
      link
      address
      authProofUrl
    }
    nftProvenance {
      title
      from {
        address
        link
        name
        authProofUrl
      }
      to {
        name
        link
        address
        authProofUrl
      }
      date
      meta
    }
    networkType
    state
    chainId
    hasProvenance
    assetAuthProof
    creator {
      name
      link
      address
      authProofUrl
    }
    receipt {
      key
      value
    }
  }
}
`